import React from 'react';
import styled from 'styled-components';
import translate from '@e4/intl/translate.macro';
import { eBank, logOff } from './menuItems';

import { IsMediumScreen } from '@e4/ui';
import { UnorderedList, AnchorItem, ButtonItem } from './UnorderedList';
import BurgerMenu from './BurgerMenu/BurgerMenu';

const WebMenu = () => (
  <NavigationRow aria-label={translate('webMenu.nav.ariaLabel')}>
    <UnorderedList>
      <AnchorItem {...logOff} />
      <IsMediumScreen>
        {(match) =>
          match ? <ButtonItem {...eBank} /> : <BurgerMenu items={[eBank]} />
        }
      </IsMediumScreen>
    </UnorderedList>
  </NavigationRow>
);

const NavigationRow = styled.nav`
  display: flex;
  flex-direction: row-reverse;
  flex: 1;
  height: 100%;
`;

export default WebMenu;
